import { isTopologyRequestParameters } from '@ipfabric/utils';
import { fitGraphToView } from 'components/Graph/commands/fitGraphToView';
import { loadGraph } from 'components/Graph/commands/loadGraph';
import type { GraphCommandFactory } from 'components/Graph/model/GraphCommandContext';

export const recalculateLayout: GraphCommandFactory =
  (cmdContext, dispatch) => async () => {
    const parameters = cmdContext.getState().graphMetadata?.parameters;
    if (parameters === undefined) {
      return;
    }
    await dispatch(loadGraph, {
      nodePositions: {},
      overlay: 'keep',
      parameters: isTopologyRequestParameters(parameters)
        ? {
            ...parameters,
            recalculateLayout: true,
          }
        : parameters,
    });
    setTimeout(() => {
      dispatch(fitGraphToView);
    }, 0);
  };
